/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Link } from "react-router-dom";
import L from "../Lang"
import BaseCom from "../BaseCom";
import DataTable from "../DataTable";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import { SidebarGlobal } from "../_Sidebar";
import Icon from "../Icon";

class ProductLineList extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            list: []
        }
    }

    componentDidMount() {
        this.fillList('/api/productline/list', 'list');
        SidebarGlobal.setSubNav(<>
            <button className="btn btn-primary" onClick={() => this.props.navigate('/productline/new')}><Icon icon="faPlus" /> <span className="d-none d-md-inline"><L>New</L></span></button>
        </>);
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    render() {
        const columns = [
            { name: 'edit', title: '', valueFunc: (row) => <Link to={`/productline/${row.id}`} title="Edit"><Icon icon="faPencil" /></Link>, width: '25px' },
            { name: 'id', title: 'ID', width: '50px', valueFunc: (row) => <Link to={`/productline/${row.id}`} title="Edit">{row.id}</Link> },
            { name: 'name', title: 'Name', valueFunc: (row) => <Link to={`/productline/${row.id}`} title="Edit">{row.name}</Link> },
            { name: 'active', title: 'Active', valueFunc: (row) => row.isDisabled ? 'No' : 'Yes' }
        ];
        return <div className="container-fluid">
            <h1><L>Product Line List</L></h1>
            <DataTable columns={columns} data={this.state.list} />
        </div>
    }
}

export default withParamsAndNavigate(ProductLineList);